import { FlatTreeControl } from '@angular/cdk/tree';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { DragDropService } from '@app/shared/services/drag-drop/drag-drop.service';
import { environment } from '@env/environment';
import { v4 as uuidv4 } from 'uuid';

import { ToastrService } from 'ngx-toastr';
import { element } from 'protractor';
import { RootStoreState, loginStoreActions, vaultStoreActions } from '../../root-store/index';

import { Observable, Subscription, fromEvent, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InboxSettingsService } from '@app/shared/services/settings/inbox-settings/inbox-settings.service';
import { AddSubfolderComponent } from '../vault/components/dialogs/add-subfolder/add-subfolder.component';
import { MyDeliveryHeaderComponent } from './sub-component/my-delivery-header/my-delivery-header.component';
import { FileTypeListSizeEnum, FileUploadedLimitExtension } from '@app/enum/FileTypeListSizeEnum';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { MatchInboxFileComponentV2 } from '../inbox-v2/component/my-inbox/match-inbox-file-v2/match-inbox-file.component-v2';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { AddDocumentComponent } from '../vault/components/add-document/add-document.component';
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { CommonService, DocumentService } from '@app/shared/services';
import { fetchAuthSession } from '@aws-amplify/auth';
import JSZip from 'jszip';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { AnimationOptions } from 'ngx-lottie';
import { AddVaultDialogComponent } from '@app/shared/component/add-vault-dialog/add-vault-dialog.component';
import { foreverDeletedRemainingDays } from '@app/shared/models/constants/constant';
import { MxTaskbarService } from '@app/shared/services/mx-taskbar/mx-taskbar.service';
import { DiscoveryService } from '@app/shared/services/discovery/discovery.service';

interface DIRECTORY {
  name: string;
  data: any;
  children?: DIRECTORY[];
}

let TREE_DATA: DIRECTORY[] = [];

interface DirectoryFlatNode {
  expandable: boolean;
  name: string;
  level: number;
  data: any;
  completed: boolean;
}
export enum VaultUserFormOrigin {
  workspace = 'workspace',
  vault = 'vault',
  officeVault = 'office-vault',
}
export enum fileStatus {
  success = 'success',
  fail = 'fail',
  running = 'running',
}
@AutoUnsubscribe()
@Component({
  selector: 'mobiledelivery',
  templateUrl: './my-delivery.component.html',
  // styleUrls: ['./my-delivery.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyDeliveryComponent implements OnInit, OnDestroy {
  private _snackBar = inject(MatSnackBar);
  horizontalPosition: MatSnackBarHorizontalPosition = 'start';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';
  @Output() moveNextPreviousEvent = new EventEmitter<any>();
  @Input() data;
  @Input() payload;
  @Input() suggestion_id;
  @Input() single_upload = false;
  @Input() hideHeader = false;
  @Input() origin = 'mobile';
  @Input() is_inline = false;
  @Input() upload_file;
  @Input() dragged_data;
  is_mobile_delivery = false;
  button_text = 'View template';
  @Output() mxDialogMinimized = new EventEmitter<string>();

  currentVaultId;
  fileListDataTree = [];
  fileList = [];
  loginStateObject;

  // Add a Map to track files by UUID to prevent race conditions
  private fileMap = new Map<string, any>();
  private fileListIndex = 0;

  FileUploadedLimit = FileTypeListSizeEnum.FileUploadedLimit;
  FileUploadedLimitExtension = FileUploadedLimitExtension;
  screenWidth: number;
  resizeObservable$: Observable<Event>;
  progressdata = [];
  hasFile = false;
  completedCount = 0;
  pre_upload_enable = false;
  dialogRef;
  @Input() dialogId: string;
  selectedItemsArray = [];
  isActiveDrag = false;
  is_workspace = false;
  private transformer = (node: any, level: number) => {
    let data = node.data;
    data.element.name = '1';
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
      data: data,
    };
  };

  treeControl = new FlatTreeControl<DirectoryFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this.transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  FiletListDataList: Array<any> = [];
  subscription: Subscription = new Subscription();
  showLader;
  routeId;
  searchText = '';
  ai_disable = false;
  animation: AnimationOptions = {
    path: '/assets/lottie/animation-4.json',
  };

  vaultList = [];
  calledFirst = true;
  timeoutId;
  folderList = [];
  totalFileCount: any = 0;
  vaultid: string;
  is_my_data: boolean;

  // Worker references for proper cleanup
  private activeWorkers: Map<string, Worker> = new Map();
  currentVaultDetails: any = null;
  constructor(
    private store$: Store<RootStoreState.State>,
    private dragDropService: DragDropService,
    private cd: ChangeDetectorRef,
    private mxTaskbarService: MxTaskbarService,
    private documentService: DocumentService,
    private injector: Injector,
    private _dialog: MatDialog,
    private commonService: CommonService,
    private _inboxService: InboxSettingsService,
    private _toastr: ToastrService,
    private vaultService: VaultStoreEffects,
    private _router: Router,
    private _route: ActivatedRoute,
    private toastr: ToastrService,
    private loginService: LoginStoreEffects,
    private discoveryService: DiscoveryService
  ) {
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        this.loginStateObject = { ...state.data };
        if (this.loginStateObject.id && this.calledFirst) {
          this.calledFirst = false;
          this.getVaultList();
        }
      })
    );
    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.vaultList = state.vaults;
        // Re-set current vault ID and get details when vault list is loaded
        this.setCurrentVaultId();
      })
    );
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    // Terminate all active workers
    this.activeWorkers.forEach((worker, workerId) => {
      worker.terminate();
    });
    this.activeWorkers.clear();
  }
  onInputChange(value: string) {
    this.searchText = value;
  }
  getvaultdetailsbysuggestion() {
    this.subscription.add(
      this.discoveryService.getDocumentsList().subscribe((response) => {
        if (response && Array.isArray(response) && response.length > 0) {
          let matchingItem = null;

          // Search through all objects in the response array
          for (const responseItem of response) {
            if (responseItem.setupItems && Array.isArray(responseItem.setupItems)) {
              // Search through setupItems array for matching suggestion_id
              matchingItem = responseItem.setupItems.find((item) => item.suggestion_id === this.suggestion_id);

              // If found, break out of the loop
              if (matchingItem) {
                break;
              }
            }
          }

          if (matchingItem && matchingItem.vid) {
            this.currentVaultDetails = this.vaultList.find((vault) => vault.id === matchingItem.vid);
          }
        }
      })
    );
  }
  actionEvent(event: any) {
    if (event.action === 'clearSelection') {
      this.selectedItemsArray.forEach((x) => {
        x.selected = false;
      });
      this.listSelectedItems();
    } else if (event.action === 'deleteSelection') {
      const selectedFiles = this.fileList.filter((x) => x.selected);
      this.deleteEventHandler(
        selectedFiles.map((x) => x.vault_user_form_id),
        true
      );
    } else if (event.action === 'saveSelection') {
      this.fileList.forEach((x, index) => {
        if (x.selected) {
          this.saveFile(x, index);
          x.selected = false;
        }
      });
      this.listSelectedItems();
    }
  }

  clearSearchAction() {
    this.searchText = '';
  }

  selectAiSuggestion(file: any) {
    file.vault_details = file?.suggestion;
    if (this.suggestion_id) {
      this.currentVaultDetails = file?.suggestion;
    }
  }

  selectVault(file: any, vault: any) {
    file.vault_details = vault;
    if (this.suggestion_id) {
      this.currentVaultDetails = vault;
    }
  }
  addNewVault(file, index, reload = true) {
    const modalRef = this._dialog.open(AddVaultDialogComponent, {
      panelClass: 'full-window-dialog-2',
      disableClose: true,
      autoFocus: false,
      data: {
        user_id: this.loginStateObject?.id,
        fromDiscovery: false,
        vault_suggestion_details: file.suggestion,
      },
    });
    this.subscription.add(
      modalRef.afterClosed().subscribe((res) => {
        if (res.message) {
          const findIndex = this.fileList.findIndex((x) => x.id === file.id);
          if (findIndex >= 0) {
            this.fileList[findIndex]['vault_details'] = res.data;
            // Get the UUID from the file object instead of using index
            const fileObj = this.fileList[findIndex];
            if (fileObj && fileObj.uuid) {
              this.setVaultId(file.vault_user_form_id, res.data.id, fileObj.uuid, reload);
            }
          }

          // this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.stateObject?.userId, false));
        }
      })
    );
  }
  closeDialog() {
    try {
      this.dialogRef.close({
        success: false,
        fileList: this.fileList,
      });
    } catch (error) {}
  }

  setCurrentVaultId() {
    if (this._router.url.includes('vault') && this._router.url.split('/').length === 3 && this._router.url.split('/')[1] === 'vault') {
      this.currentVaultId = this._router.url.split('/')[2];
      this.ai_disable = true;
    } else if (this.payload?.setVaultId) {
      this.ai_disable = true;
      this.currentVaultId = this.payload.vault_id;
      this.getCurrentVaultDetails();
      // } else if (this.is_my_data) {
      //   // For my_data context, get vault ID from URL or payload
      //   if (this._router.url.includes('mydata')) {
      //     const urlParts = this._router.url.split('/');
      //     const mydataIndex = urlParts.findIndex((part) => part === 'mydata');
      //     if (mydataIndex !== -1 && urlParts[mydataIndex + 1]) {
      //       this.currentVaultId = urlParts[mydataIndex + 1];
      //       this.getCurrentVaultDetails();
      //     }
      //   } else if (this.payload?.vault_id) {
      //     this.currentVaultId = this.payload.vault_id;
      //     this.getCurrentVaultDetails();
      //   }
    }
  }

  getCurrentVaultDetails() {
    if (this.currentVaultId && this.vaultList.length > 0) {
      this.currentVaultDetails = this.vaultList.find((vault) => vault.id === this.currentVaultId);
      this.cd.detectChanges();
    }
  }
  getVaultList() {
    if (this._router.url.includes('mobiledelivery')) {
      this.is_mobile_delivery = true;
      this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.loginStateObject?.id, false));
    }
  }
  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );
    if (this.hideHeader) {
      this.dialogRef = this.injector.get(MatDialogRef<MyDeliveryComponent>);
    }
    if (this._router.url.includes('workspace')) {
      this.routeId = this.documentService.getWorSpaceId();
      this.is_workspace = true;
    }
    if (this._router.url.includes('mydata')) {
      this.is_my_data = true;
    }
    if (this._router.url.includes('mobiledelivery')) {
      this.is_mobile_delivery = true;
      this.store$.dispatch(new loginStoreActions.LoginRequestAction());
    }

    // Set current vault ID after all flags are set
    this.setCurrentVaultId();
    // Try to get vault details immediately if vault list is already loaded
    this.getCurrentVaultDetails();
    if (!this._router.url.includes('my-inbox')) {
      this.button_text = 'Go to Inbox';
    }
    if (this.upload_file) {
      this.pre_upload_enable = true;
      this.uploadFile(this.upload_file);
    }
    if (this.dragged_data) {
      this.pre_upload_enable = true;
      this.dragged(this.dragged_data);
    }
    if (this.suggestion_id) {
      this.getvaultdetailsbysuggestion();
    }
  }
  getFileExtension(filePath) {
    // Use the `split` method to break the path into an array using the '.' separator
    const parts = filePath.split('.');

    // The last part of the array will be the file extension
    const extension = '.' + parts[parts.length - 1];

    return extension;
  }

  renameFile(element, index) {
    const dialogRef = this._dialog.open(AddSubfolderComponent, {
      width: '400px',
      data: {
        title: 'Rename',
        buttonName: 'Rename',
        currentFolderName: element.name.split('.').slice(0, -1).length == 0 ? element.name : element.name.split('.').slice(0, -1).join('.'),
      },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((data) => {
        if (data && data.confirmation) {
          let model = {
            user_id: this.loginStateObject.id,
            id: element.id,
            custom_folder_name: data?.subfolderName + this.getFileExtension(element.name),
          };

          this.subscription.add(
            this._inboxService.updateInboxAttachmentFileName(model).subscribe((res) => {
              if (res.status == 200) {
                this.fileList[index].name = data?.subfolderName + this.getFileExtension(element.name);
                this.cd.detectChanges();
              }
            })
          );
        }
      })
    );
  }
  deleteFile(file, i) {
    // only splice array when item is found

    this.deleteEventHandler([file.vault_user_form_id], false, i);
  }
  deleteEventHandler(id, action = false, i = -1) {
    let attachmentFilesIds: number[] = id;
    const modelRequest = {
      type: 'form',
      ids: attachmentFilesIds,
    };
    const dialogRef = this._dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Move to trash?',
        materialIcon: 'delete',
        text: `This file will be deleted forever from your trash after ${foreverDeletedRemainingDays} days.`,
        proceedTitle: 'Move to Trash',
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation?.confirmation) {
          this.subscription.add(
            this.commonService.moveToTrashForm(modelRequest).subscribe(
              (result: any) => {
                if (result.status == 200) {
                  this.toastr.success(`The ${attachmentFilesIds.length > 1 ? 'files' : 'file'}  has been deleted.`);
                  if (action) {
                    this.selectedItemsArray.forEach((x) => {
                      x.selected = false;
                      x.deleted = true;
                    });
                    this.listSelectedItems();
                  } else if (i !== -1) {
                    this.fileList[i].deleted = true;
                  }
                  this.cd.detectChanges();
                }
              },
              (error: any) => {}
            )
          );
        }
      })
    );
  }

  openFile(file) {
    if (this.button_text === 'Go to Inbox') {
      this.closeDialog();
      this._router.navigateByUrl('my-inbox');
    } else {
      const dialogOpen = this._dialog.open(AddDocumentComponent, {
        disableClose: true,
        data: {
          file: {
            ...file,
            id: file?.vault_user_form_id ? file.vault_user_form_id : file.id,
          },

          mode: 'edit',
          isintelligent: false,
          isfileListLoad: true,
        },
        panelClass: 'full-window-dialog-add-document',
        autoFocus: false,
      });
      this.subscription.add(dialogOpen.afterClosed().subscribe(() => {}));
    }
  }

  onValueChange(event: any, file: any): void {
    file.selected = event.checked;
    this.listSelectedItems();
  }
  listSelectedItems() {
    this.selectedItemsArray = this.fileList.filter((x) => x.selected);
    this.cd.detectChanges();
  }
  findbestMatchvault(formId, uuid) {
    const fileObj = this.getFileByUUID(uuid);
    if (fileObj) {
      // Don't automatically set vault_details in my_data context
      if (!this.is_my_data) {
        fileObj.vault_details = this.vaultList.find((vault) => vault.id === this.currentVaultId);
        if (fileObj.vault_details) {
          this.payload = {
            ...this.payload,
            userId: this.loginStateObject.id,
          };
          this.setVaultId(formId, fileObj.vault_details.id, uuid);
          this.cd.detectChanges();
        }
      }
    }
    this.updateMxConnectionStatus();
  }
  async getInboxSuggestion(data_extraction_id, uuid, vault_user_form_id) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const worker = new Worker(new URL('./my-inbox-suggestion-by-id.worker', import.meta.url), { type: 'module' });
        const workerId = `suggestion_${uuid}`;
        this.activeWorkers.set(workerId, worker);

        let data = {
          token: '',
          url: '',
        };
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;

        data.url = `${environment.apiUrl}/api/data-extraction/data-extraction-suggestion-by-id/${data_extraction_id}`;
        worker.onmessage = async ({ data }) => {
          //return security key generated by worker process
          worker.terminate();
          this.activeWorkers.delete(workerId);
          resolve(data);
          let res = data.data.data[0];
          this.timeoutId = setTimeout(() => {
            if (res.status !== 'end') {
              this.getInboxSuggestion(data_extraction_id, uuid, vault_user_form_id); // Call the method again after 5 seconds
            } else {
              this.updateFileByUUID(uuid, { ai_processing: false });
              this.cd.detectChanges();
              this.updateMxConnectionStatus();
              if (this.payload?.setVaultId && this.payload?.vault_id) {
                this.setVaultId(vault_user_form_id, null, uuid);
              } else {
                this.setVaultData(res, uuid);
              }
            }
          }, 15000);
          this.cd.detectChanges();
        };
        worker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateCreatePresignedUrl({}));
      }
    });
  }
  setVaultData(suggestion, uuid) {
    // For suggestion_id context, only set suggestion for dropdown menu, don't set vault_details
    if (this.suggestion_id) {
      // Only set suggestion for dropdown menu when suggestion_id exists
      // Don't set vault_details to keep files clean
      if (suggestion?.vault_id) {
        let vault = this.vaultList.find((x) => x.id === suggestion.vault_id);
        this.updateFileByUUID(uuid, { suggestion: vault });
      } else if (suggestion?.new_vault_name && suggestion?.new_vault_type) {
        this.updateFileByUUID(uuid, {
          suggestion: {
            id: -1,
            name: suggestion.new_vault_name,
            type: suggestion.new_vault_type,
          },
        });
      }
    } else if (suggestion?.vault_id) {
      let vault = this.vaultList.find((x) => x.id === suggestion.vault_id);
      this.updateFileByUUID(uuid, { vault_details: vault });
      this.updateFileByUUID(uuid, { suggestion: vault });
    } else if (suggestion?.new_vault_name && suggestion?.new_vault_type) {
      this.updateFileByUUID(uuid, {
        vault_details: {
          id: -1,
          name: suggestion.new_vault_name,
          type: suggestion.new_vault_type,
        },
      });
      this.updateFileByUUID(uuid, {
        suggestion: {
          id: -1,
          name: suggestion.new_vault_name,
          type: suggestion.new_vault_type,
        },
      });
    }
    this.cd.detectChanges();
  }

  async setAssocaiteFormId(formid) {
    if (this.payload?.currentFormId && this.payload?.userId) {
      let data = {
        token: null,
        url: null,
        user_id: this.payload?.userId,
        vault_user_form_id: this.payload?.currentFormId,
        created_by_user_id: this.payload?.userId,
        association_type: 'Documents',
        associate_vault_user_form_id: formid,
      };
      return await new Promise(async (resolve) => {
        if (typeof Worker !== 'undefined') {
          const worker = new Worker(new URL('./upload-presign-url.worker', import.meta.url), { type: 'module' });
          const workerId = `association_${Date.now()}`;
          this.activeWorkers.set(workerId, worker);

          const session = await fetchAuthSession();
          const idToken = session.tokens?.idToken?.toString();

          const token = `Bearer ${idToken}`;
          data.token = token;
          data.url = `${environment.apiUrl}/api/vault/form-association`;
          worker.onmessage = ({ data }) => {
            //return security key generated by worker process
            worker.terminate();
            this.activeWorkers.delete(workerId);
            resolve(data);
            this.cd.detectChanges();
          };
          worker.postMessage(data);
        } else {
          resolve(this.generateDataKeyPairFileStatus(data));
        }
      });
    }
  }
  saveFile(file, index, reload = true) {
    // For suggestion_id context, always use currentVaultDetails
    if (this.suggestion_id && this.currentVaultDetails) {
      // Check if currentVaultDetails is a new vault that needs to be created
      if (this.currentVaultDetails.id === -1) {
        this.addNewVault(file, index, reload);
      } else {
        // Use currentVaultDetails for existing vault
        this.setVaultId(file.vault_user_form_id, this.currentVaultDetails.id, file.uuid, reload);
      }
    } else if (file.vault_details && file.vault_details.id == -1) {
      this.addNewVault(file, index, reload);
    } else if (file.vault_details) {
      // Use UUID instead of index
      this.setVaultId(file.vault_user_form_id, file.vault_details.id, file.uuid, reload);
    }
  }
  async setVaultId(formid, vault_id = null, uuid = '', reload = true) {
    let data = {
      token: null,
      url: null,
      payload: [
        {
          vault_id: vault_id ? vault_id : this.payload?.vault_id,
          vault_user_form_id: formid,
        },
      ],
    };
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const worker = new Worker(new URL('./update-form-group.worker', import.meta.url), { type: 'module' });
        const workerId = `updateGroup_${uuid}_${Date.now()}`;
        this.activeWorkers.set(workerId, worker);

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = `${environment.apiUrl}/api/vault/update-vault-for-vault-user-form`;
        worker.onmessage = ({ data }) => {
          //return security key generated by worker process
          worker.terminate();
          this.activeWorkers.delete(workerId);
          resolve(data);
          if (uuid !== '' && reload) {
            this.updateFileByUUID(uuid, { saved: true });
          } else {
            const fileObj = this.fileMap.get(uuid);
            if (fileObj) {
              // Also update the array reference to trigger change detection
              const index = this.fileList.findIndex((item) => item.uuid === uuid);
              if (index !== -1) {
                this.fileList[index].saved = true;
              }
              this.cd.detectChanges();
              return true;
            }
          }
        };
        worker.postMessage(data);
      } else {
        resolve(this.generateDataKeyPairFileStatus(data));
      }
    });
  }
  generateDataKeyPairFileStatus(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }

  generatecreateFileAfterS3UrlCrete(data: any): unknown {
    throw new Error('Method not implemented.');
  }

  generateCreatePresignedUrl(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }

  createrTreeStructureData(dataList, isUploadDedByFolder) {
    dataList.forEach(async (element) => {
      if (isUploadDedByFolder) {
        if (element.data.name == element.name) {
          this.cd.detectChanges();
          this.fileListDataTree.push(element);
        } else {
          this.createrTreeStructureData(element.children, isUploadDedByFolder);
        }
      } else {
        if (element.data.isFile) {
          this.cd.detectChanges();
          this.fileListDataTree.push(element);
        } else {
          this.createrTreeStructureData(element.children, isUploadDedByFolder);
        }
      }
    });
    this.showLader = false;
    this.cd.detectChanges();
  }

  submitForm() {
    this.moveNextPreviousEvent.next({ status: 'forward', id: this.data.id });
  }
  dropleave(ev) {}

  allowDrop(ev) {
    ev.preventDefault();
  }

  drop(ev) {}
  unzipFile(file) {
    const reader = new FileReader();

    reader.onload = async (e: any) => {
      const arrayBuffer = e.target.result;
      const zip = await JSZip.loadAsync(arrayBuffer);

      zip.forEach(async (relativePath, fileEntry) => {
        if (!fileEntry.dir) {
          const fileContent = await fileEntry.async('blob'); // or 'text' / 'arraybuffer' as needed
          const fileNameOnly = relativePath.split('/').pop();
          const unzippedFile = new File([fileContent], fileNameOnly, { type: fileContent.type });
          if (unzippedFile.name.toLowerCase().includes('zip')) {
            this.unzipFile(unzippedFile);
          } else {
            this.totalFileCount++;
            this.uploadDocument(unzippedFile, relativePath);
          }
        }
      });

      this.cd.markForCheck();
    };

    reader.readAsArrayBuffer(file);
  }
  generateTimestampUUID(): string {
    // const timestamp = Date.now(); // milliseconds since epoch
    // const randomPart = Math.random().toString(36).substring(2, 10); // random alphanumeric
    // return `${timestamp}-${randomPart}`;
    return uuidv4();
  }
  async uploadFile(event) {

    const items = event.target.files;

    this.cd.detectChanges();

    // Process files individually to avoid race conditions
    for (let i = 0; i < items.length; i++) {
      const file = items[i];
      if (file?.name.toLowerCase().includes('zip')) {
        this.unzipFile(file);
      } else {
        this.totalFileCount++;
        await this.uploadDocument(file, file?.name);
      }
    }
    this.cd.markForCheck();
  }
  async uploadDocument(element, name) {
    let fileSizeInMb = (element.size / (1024 * 1024)).toFixed(2);
    const uuid = this.generateTimestampUUID();

    if (+fileSizeInMb > this.FileUploadedLimit) {
      const fileObj = {
        name: element.name,
        status: 'fail',
        size: element.size,
        error_message: 'This file exceeds the maximum size of ' + this.FileUploadedLimit + 'MB',
        type: element.type,
        id: '',
        link: '',
        origin: this.origin,
        deleted: false,
        selected: false,
        saved: false,
        ai_processing: false,
        vault_details: null,
        is_organized: false,
        vault_user_form_id: null,
        suggestion: null,
        uuid: uuid,
      };

      this.fileList.push(fileObj);
      this.fileMap.set(uuid, fileObj);
      this.completedCount = this.completedCount + 1;
      return;
    } else {
      const extension = element['name'].split('?')[0].split('.').pop();
      if (this.FileUploadedLimitExtension.findIndex((item) => item == extension.toUpperCase()) == -1) {
        const fileObj = {
          name: element.name,
          status: 'fail',
          ai_processing: false,
          size: element.size,
          error_message: 'This is an unsupported file type',
          type: element.type,
          id: '',
          link: '',
          vault_details: null,
          origin: this.origin,
          vault_user_form_id: null,
          deleted: false,
          selected: false,
          saved: false,
          suggestion: null,
          uuid: uuid,
        };

        this.fileList.push(fileObj);
        this.fileMap.set(uuid, fileObj);
        this.completedCount = this.completedCount + 1;
        return;
      } else {
        const fileObj = {
          name: element.name,
          status: 'running',
          size: element.size,
          error_message: '',
          type: element.type,
          saved: false,
          id: '',
          deleted: false,
          selected: false,
          link: '',
          origin: this.origin,
          vault_details: null,
          vault_user_form_id: null,
          ai_processing: false,
          suggestion: null,
          uuid: uuid,
        };

        this.fileList.push(fileObj);
        this.fileMap.set(uuid, fileObj);

        let data: any = {
          user_id: this.loginStateObject.id,
          name: element.name,
          file_name_without_extesion:
            element.name.split('.').slice(0, -1).length == 0 ? element.name : element.name.split('.').slice(0, -1).join('.'),
          display_file_name: element.name,
          size: element.size,
          type: element.type,
          origin: this.origin,
          uuid: uuid, // Add UUID to track the request
        };
        if (this.is_workspace) {
          data = {
            workspace_id: this.routeId,
            ...data,
          };
        }
        await this.CreteCreatePresignedUrl(data, element, uuid);
      }
    }
  }

  findIndexIdFormUUid(uuid) {
    const index = this.fileList.findIndex((item) => item.uuid === uuid);
    // eslint-disable-next-line no-console
    console.log('****************** index ****************', index, '****************** index ****************');
    return index;
  }

  // New method to safely update file by UUID
  private updateFileByUUID(uuid: string, updates: Partial<any>) {
    const fileObj = this.fileMap.get(uuid);
    if (fileObj) {
      Object.assign(fileObj, updates);
      // Also update the array reference to trigger change detection
      const index = this.fileList.findIndex((item) => item.uuid === uuid);
      if (index !== -1) {
        this.fileList[index] = { ...fileObj };
      }
      this.cd.detectChanges();
      return true;
    }
    return false;
  }

  // New method to safely get file by UUID
  private getFileByUUID(uuid: string) {
    return this.fileMap.get(uuid);
  }
  async CreteCreatePresignedUrl(data, file, uuid) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const worker = new Worker(new URL('./upload-presign-url.worker', import.meta.url), { type: 'module' });
        const workerId = `presignUrl_${uuid}`;
        this.activeWorkers.set(workerId, worker);

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = `${environment.apiUrl}/api/vault/inbox-file-upload`;

        worker.onmessage = async ({ data }) => {
          worker.terminate();
          this.activeWorkers.delete(workerId);
          let res = data.data;
          if (res['uploadLimitExceeded']) {
            this.completedCount = this.completedCount + 1;
            this.updateMxConnectionStatus();
            this.updateFileByUUID(uuid, { status: 'fail' });
            return;
          } else if (res['limit_exceeded']) {
            this.updateFileByUUID(uuid, { status: 'fail' });
            this.completedCount = this.completedCount + 1;
            this.updateMxConnectionStatus();
            return;
          } else {
            // Validate that the response matches the original file
            if (res.vault_user_form_id) {
              this.updateFileByUUID(uuid, { vault_user_form_id: res.vault_user_form_id });
              this.findbestMatchvault(res.vault_user_form_id, uuid);
              this.setAssocaiteFormId(res.vault_user_form_id);
              await this.saveFileAfterS3UrlCrete(res, file, res.id, uuid, res.vault_user_form_id);
            }
          }
          resolve(data);
        };
        worker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateCreatePresignedUrl(data));
      }
    });
  }
  updateMxConnectionStatus() {
    if (this.fileList.filter((x) => x.ai_processing).length === 0 && this.completedCount === this.fileList.length) {
      this.mxTaskbarService.updateMxConnectionStatus(
        this.dialogRef,
        this.dialogId,
        'completed',
        `${this.completedCount} of ${this.fileList.length} uploads complete`
      );
    } else {
      this.mxTaskbarService.updateMxConnectionStatus(
        this.dialogRef,
        this.dialogId,
        'in-progress',
        `${this.completedCount} of ${this.fileList.length} uploads complete`
      );
    }
  }
  async saveFileAfterS3UrlCrete(res, file, id, uuid, vault_user_form_id) {
    let data = {
      file: file,
      token: null,
      url: null,
      fileType: null,
    };
    const xhr = new XMLHttpRequest();

    await this.createFileAfterS3UrlCrete(data, res['upload_url'], file.type, file, id, uuid, vault_user_form_id);
  }
  async createFileAfterS3UrlCrete(data, url, type, file, id, uuid, vault_user_form_id) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const worker = new Worker(new URL('./upload-s3-image.worker', import.meta.url), { type: 'module' });
        const workerId = `s3Upload_${uuid}`;
        this.activeWorkers.set(workerId, worker);

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = url;
        data.fileType = type;
        data.file = file;
        worker.onmessage = async ({ data }) => {
          //return security key generated by worker process
          worker.terminate();
          this.activeWorkers.delete(workerId);
          resolve(data);

          this.cd.detectChanges();

          this.updateFileByUUID(uuid, { id: id });

          this.updateFileStatus({ id: id, suggestion_id: this.suggestion_id }, uuid, id, vault_user_form_id);
          this.cd.detectChanges();
        };
        worker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generatecreateFileAfterS3UrlCrete(data));
      }
    });
  }
  async updateFileStatus(data, uuid, id, vault_user_form_id) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const worker = new Worker(new URL('./upload-status-update.worker', import.meta.url), { type: 'module' });
        const workerId = `statusUpdate_${uuid}`;
        this.activeWorkers.set(workerId, worker);

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = `${environment.apiUrl}/api/vault/inbox-file-upload-status`;
        worker.onmessage = ({ data }) => {
          //return security key generated by worker process
          worker.terminate();
          this.activeWorkers.delete(workerId);
          resolve(data);
          this.updateFileByUUID(uuid, {
            link: data.data.data.link,
            status: 'success',
          });
          this.completedCount = this.completedCount + 1;
          if (data.data.data.data_extraction_execution_id != null) {
            this.updateFileByUUID(uuid, { ai_processing: true });
            this.getInboxSuggestion(data.data.data.data_extraction_execution_id, uuid, vault_user_form_id);
          }
          this.updateMxConnectionStatus();
          this.cd.detectChanges();
        };
        worker.postMessage(data);
      } else {
        this.updateFileByUUID(uuid, {
          status: 'fail',
          error_message: 'There was an issue uploading this',
        });
        this.completedCount = this.completedCount + 1;
        this.updateMxConnectionStatus();
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateDataKeyPairFileStatus(data));
      }
    });
  }

  myFunction(event) {
    this.isActiveDrag = false;
    this.cd.detectChanges();
  }

  onDragStart(event) {
    this.isActiveDrag = true;
    this.cd.detectChanges();
  }
  onDrag(event) {
    this.isActiveDrag = true;
    this.cd.detectChanges();
  }
  onDragEnd(event) {
    this.isActiveDrag = false;
    this.cd.detectChanges();
  }
  minimizeMxDialog() {
    this.mxDialogMinimized.emit(this.dialogId);
    this.mxTaskbarService.minimizeMxDialog(this.dialogRef, this.dialogId, `${this.completedCount} of ${this.fileList.length} uploads complete`);
  }
  async dragged(event: DragEvent) {
    this.isActiveDrag = false;
    this.folderList = [];

    const items = event.dataTransfer?.items;
    if (!items) return;

    this.cd.detectChanges();

    const promises: Promise<any>[] = [];

    for (let i = 0; i < items.length; i++) {
      const entry = items[i].webkitGetAsEntry();
      if (entry) {
        promises.push(this.scanAndLogFiles(entry));
      }
    }

    await Promise.allSettled(promises);
    this.cd.markForCheck();
  }

  async scanAndLogFiles(entry: any): Promise<void> {
    if (entry.isDirectory) {
      return new Promise((resolve) => {
        const reader = entry.createReader();
        reader.readEntries(async (entries: any[]) => {
          const subPromises = entries.map((e) => this.scanAndLogFiles(e));
          await Promise.allSettled(subPromises);

          entry.originalFile = undefined;
          this.data.folderList.push(entry);

          resolve();
        });
      });
    } else {
      return new Promise((resolve) => {
        entry.file(async (file: File) => {
          this.cd.detectChanges();

          if (file.name.toLowerCase().includes('zip')) {
            await this.unzipFile(file);
          } else {
            this.totalFileCount++;
            await this.uploadDocument(file, file.name);
          }

          resolve();
        });
      });
    }
  }
  backForm() {
    this.moveNextPreviousEvent.next({ status: 'backward' });
  }
}
